export default "__VITE_ASSET__BfD1ebFu__"